import { settings } from "../../../../settings/settings-util";
import h from "virtual-dom/h";
import SurveyQuestionBuilder from "./surveyQuestionBuilder";
import SurveyRadioButtonsBuilder from "./surveyRadioButtonsBuilder";
import SurveyFreeformTextBuilder from "./surveyFreeformTextBuilder";
import SurveyDropdownBuilder from "./surveyDropdownBuilder";


export default class SurveyBodyBuilder
{
    //#region Public Interface

    constructor(passedSettings, mutators = [])
    {
        this._settings = passedSettings;
        this._mutators = mutators;

        this._questionBuilder = new SurveyQuestionBuilder(this._settings);
        this._radioButtonsBuilder = new SurveyRadioButtonsBuilder(this._settings, mutators);
        this._freeformTextBuilder = new SurveyFreeformTextBuilder(this._settings);
        this._dropdownBuilder = new SurveyDropdownBuilder(this._settings);
    }

    initialize(store)
    {
        this._store = store;
        this._questionBuilder.initialize(store);
        this._radioButtonsBuilder.initialize(store);
        this._freeformTextBuilder.initialize(store);
        this._dropdownBuilder.initialize(store);
    }

    buildBody(bodyConfig, surveyId)
    {
        const bodyClassName = this._settings.classNames.surveyBody || settings.classNames.surveyBody;
        const bodyItems = [];
        if(bodyConfig.Prompt){
            bodyItems.push(this.buildPrompt(bodyConfig.Prompt));
        }
        if (bodyConfig.Question)
        {
            bodyItems.push(this._questionBuilder.buildQuestion(bodyConfig.Question, surveyId));
        }
        else if (bodyConfig.RadioButtons)
        {
            bodyItems.push(this._radioButtonsBuilder.buildRadioButtons(bodyConfig.RadioButtons, surveyId));
        }
        else if(bodyConfig.Dropdown)
        {
            bodyItems.push(this._dropdownBuilder.buildDropdown(bodyConfig.Dropdown, surveyId));
        }
        if (bodyConfig.FreeformText)
        {
            bodyItems.push(this._freeformTextBuilder.buildFreeformText(bodyConfig.FreeformText));
        }

        return h("div", { className: bodyClassName }, bodyItems);
    }

    buildPrompt(Prompt){
        return h('div', { className : this._settings.classNames.surveyPrompt }, Prompt);
    }

    //#endregion
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/simple-feedback-overlay/src/builders/surveyBodyBuilder.js